import { Trans, useTranslation } from "react-i18next";
import CodeBlock from "../components/CodeBlock";

export default function GettingStarted() {
  const { t } = useTranslation();

  return (
    <article>
      <h1>{t("gettingStarted.title")}</h1>
      <p>
        <Trans i18nKey="gettingStarted.intro" components={[<code key="0" />, <code key="1" />]} />
      </p>

      <CodeBlock
        tabs={[
          { label: "npm", code: "npm install kira-arts", language: "bash" },
          { label: "yarn", code: "yarn add kira-arts", language: "bash" },
          { label: "pnpm", code: "pnpm add kira-arts", language: "bash" },
          { label: "bun", code: "bun add kira-arts", language: "bash" },
        ]}
      />

      <h2>{t("gettingStarted.registerClientTitle")}</h2>
      <p>
        <Trans i18nKey="gettingStarted.registerClientIntro" components={[<code key="0" />]} />
      </p>

      <CodeBlock
        tabs={[
          {
            label: "ESM",
            code: `import { Client, GatewayIntentBits } from "discord.js";
import { setClient, profileImage } from "kira-arts";

const client = new Client({ intents: [GatewayIntentBits.Guilds] });

client.once("ready", () => {
  setClient(client);
});

client.login(process.env.TOKEN);`,
          },
          {
            label: "CommonJS",
            code: `const { Client, GatewayIntentBits } = require("discord.js");
const { setClient, profileImage } = require("kira-arts");

const client = new Client({ intents: [GatewayIntentBits.Guilds] });

client.once("ready", () => {
  setClient(client);
});

client.login(process.env.TOKEN);`,
          },
        ]}
      />

      <h2>{t("gettingStarted.firstCardTitle")}</h2>
      <CodeBlock title="commands/profile.ts">{`const buffer = await profileImage(interaction.user.id, {
  useRoleColor: true,
});

await interaction.reply({
  files: [{ attachment: buffer, name: "profile.png" }],
});`}</CodeBlock>

      <h2>{t("gettingStarted.watermarkTitle")}</h2>
      <p>
        <Trans
          i18nKey="gettingStarted.watermarkIntro"
          components={[<code key="0" />, <code key="1" />]}
        />
      </p>

      <CodeBlock title="index.ts">{`import { setWatermark } from "kira-arts";

setWatermark({
  text: "yourserver.dev",
  position: "bottom-right",
  opacity: 0.7,
});`}</CodeBlock>

      <h3>{t("gettingStarted.watermarkImageTitle")}</h3>
      <p>
        <Trans
          i18nKey="gettingStarted.watermarkImageIntro"
          components={[<code key="0" />, <code key="1" />]}
        />
      </p>

      <CodeBlock title="index.ts">{`setWatermark({
  imageUrl: "https://yourserver.dev/logo.png",
  position: "bottom-right",
  size: 48,
  opacity: 0.8,
});`}</CodeBlock>

      <h3>{t("gettingStarted.watermarkCombinedTitle")}</h3>
      <p>{t("gettingStarted.watermarkCombinedIntro")}</p>

      <CodeBlock title="index.ts">{`setWatermark({
  imageUrl: "https://yourserver.dev/logo.png",
  text: "yourserver.dev",
  position: "bottom-right",
  size: 40,
  fontSize: 18,
  color: "#FFFFFF",
  opacity: 0.75,
  margin: 20,
});`}</CodeBlock>

      <h3>{t("gettingStarted.watermarkOptionsTitle")}</h3>
      <p>
        <Trans
          i18nKey="gettingStarted.watermarkOptionsIntro"
          components={[<code key="0" />]}
        />
      </p>

      <CodeBlock title="KiraWatermarkOptions">{`text?: string;
imageUrl?: string;
position?: "top-left" | "top-right" | "bottom-left" | "bottom-right" | "center" | "center-left" | "center-right";
opacity?: number;
fontSize?: number;
color?: string;
margin?: number;
scale?: number;
size?: number;
offsetX?: number;
offsetY?: number;`}</CodeBlock>

      <p>
        <Trans
          i18nKey="gettingStarted.watermarkDisableNote"
          components={[<code key="0" />]}
        />
      </p>

      <p>
        <Trans
          i18nKey="gettingStarted.outro"
          components={[<a key="0" href="/docs/kira-arts/cards/profile" />, <a key="1" href="/docs/kira-arts/color-system" />]}
        />
      </p>
    </article>
  );
}
